// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/navaid-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/navaid-definitions/navaid-definitions.js';

mount([g0]);
